import Alpine from "alpinejs";

Alpine.data("video", () => ({
    selectedSource: 'upload',

    mp4Url: '',
    mp4Path: '',
    webmUrl: '',
    webmPath: '',
    posterUrl: '',
    posterPath: '',

    videoControls: false,
    loop: false,
    mute: false,
    autoplay: true,
    allowFullscreen: true,

    embedVideoUrl: '',

    dataJson: '',

    init() {
        let self = this;

        window.addEventListener('message', (event) => {
            if (event.data.type === 'change-videoSettings') {
                self.changeSettings(event.data.data);
            }
        });
    },

    changeSettings(data) {
        let json = JSON.parse(data);

        this.selectedSource = json.selectedSource;
        this.mp4Url = json.mp4Url;
        this.mp4Path = json.mp4Path;
        this.webmUrl = json.webmUrl;
        this.webmPath = json.webmPath;
        this.posterUrl = json.posterUrl;
        this.posterPath = json.posterPath;
        this.videoControls = json.videoControls === true || json.videoControls === "true";
        this.loop = json.loop === true || json.loop === "true";
        this.mute = json.mute === true || json.mute === "true";
        this.autoplay = json.autoplay === true || json.autoplay === "true";
        this.allowFullscreen = json.allowFullscreen === true || json.allowFullscreen === "true";
        this.embedVideoUrl = this.convertToIframeSrc(json.embedVideoUrl);

        if (this.selectedSource === 'upload') {
            const video = document.getElementById('videoFrame');

            video.toggleAttribute('autoplay', this.autoplay);
            video.toggleAttribute('muted', this.mute);
            video.toggleAttribute('loop', this.loop);
            video.toggleAttribute('controls', this.videoControls);

            video.load();
        }

    },

    start(json) {
        setTimeout(() => {
            this.changeSettings(JSON.stringify(json));
        }, 0);

        this.dataJson = json;

    },

    convertToIframeSrc(youtubeUrl) {
        if (youtubeUrl === null || youtubeUrl === undefined || youtubeUrl === "") {
            return null;
        }

        const url = new URL(youtubeUrl);

        // Initialize an array to hold the query parameters
        const params = [];

        if (url.hostname === "www.youtube.com" && url.searchParams.has("v")) {
            const videoId = url.searchParams.get("v");

            // Add the videoControls parameter
            if (this.videoControls) {
                params.push("controls=1");
            } else {
                params.push("controls=0");
            }

            // Add the loop parameter and ensure playlist is included for looping
            if (this.loop) {
                params.push("loop=1");
                params.push(`playlist=${videoId}`);  // For loop to work
            }

            // Add the mute parameter
            if (this.mute) {
                params.push("mute=1");
            }

            // Add the autoplay parameter
            if (this.autoplay) {
                params.push("autoplay=1");
            }

            params.push("fs=1");

            return `https://www.youtube.com/embed/${videoId}?` + params.join("&");
        } else if (url.hostname === "www.youtube.com" && youtubeUrl.indexOf("embed") > -1) {
            const regex = /\/embed\/([^?]+)/;
            const match = youtubeUrl.match(regex);

            if (match) {
                // Add the videoControls parameter
                if (this.videoControls) {
                    params.push("controls=1");
                } else {
                    params.push("controls=0");
                }

                // Add the loop parameter and ensure playlist is included for looping
                if (this.loop) {
                    params.push("loop=1");
                    params.push(`playlist=${match[1]}`);  // For loop to work
                }

                // Add the mute parameter
                if (this.mute) {
                    params.push("mute=1");
                }

                // Add the autoplay parameter
                if (this.autoplay) {
                    params.push("autoplay=1");
                }

                params.push("fs=1");

                return `https://www.youtube.com/embed/${match[1]}?` + params.join("&");
            } else {
                console.error("Invalid YouTube embed URL");
                return null;
            }
        } else if (url.hostname === "vimeo.com") {
            const videoId = url.pathname.split("/")[1];

            // Add the videoControls parameter
            if (this.videoControls) {
                params.push("controls=1");
            } else {
                params.push("controls=0");
            }

            // Add the loop parameter
            if (this.loop) {
                params.push("loop=1");
            }

            // Add the mute parameter
            if (this.mute) {
                params.push("mute=1");
            }

            // Add the autoplay parameter
            if (this.autoplay) {
                params.push("autoplay=1");
            }

            return `https://player.vimeo.com/video/${videoId}?` + params.join("&");
        } else {
            console.error("Invalid YouTube URL");
            return null;
        }
    }
}));